import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.css';


function listener(event) {
  const { data } = event;

  if (!data._h || typeof data._h !== "object") {
    // This is not coming from Happeo
    return;
  }

  if (data._h.userinfo) {
    ReactDOM.render(
      <React.StrictMode>
        <App email={data._h.userinfo.primaryEmail} />
      </React.StrictMode>, document.getElementById('root'));
  }
}

// Start listening to messages
window.addEventListener("message", listener);

// Post to Happeo your ID, the scope that you need
window.parent.postMessage(
  { _c: { scopes: ["userinfo.email"], resize: "600" } },
  "*",
);

// =================== REMOVE AFTER DEVELOPMENT ========================
// ReactDOM.render(
//   <React.StrictMode>
//     <App email={"FIRST_NAME.LAST_NAME@makingscience.com"} />
//   </React.StrictMode>, document.getElementById('root'));
